import tinycolor from 'tinycolor2';
import { find, filter, includes, forEach, orderBy } from 'lodash';
import uniqBy from 'lodash/uniqBy';

/**
 * Goes through each price and generates a random color for each price zone.
 * If multiple zones have same price point then same color is assigned to those
 * zones unless its a box price in which they will be treated as separate price.
 *
 * @param  {Array} prices
 * @return Array
 */
export function prepareColorCode(prices) {
  let sortedPrices = filter(prices, price => {
    return price.price_type_desc !== 'Offer';
  });

  sortedPrices = orderBy(
    sortedPrices,
    price => {
      return parseInt(price.price, 10);
    },
    'desc'
  );

  let uniqPrices = uniqBy(sortedPrices, x => parseFloat(x.price, 10)).map(
    x => x.price
  );

  let foundPrices = [];
  let colors = [];

  let color;
  let hColor = 359 / uniqPrices.length;
  let sColor = 40 / uniqPrices.length;
  let uniqIndex = 0;

  forEach(sortedPrices, price => {
    if (!includes(foundPrices, price.price)) {
      color = tinycolor({
        h: hColor * uniqIndex,
        s: 60 + sColor,
        v: 75
      }).toHexString();

      uniqIndex++;
      foundPrices.push(price.price);
    } else {
      color = find(colors, x => {
        return parseInt(price.price, 10) === parseInt(x.price, 10);
      }).color;
    }

    colors.push({
      zone: price.zone_no,
      color: color,
      price: price.price
    });
  });

  return colors;
}

/**
 * Fetches a color for a particular price zone.
 *
 * @param  {int}    zone
 * @param  {Array}  colors
 * @return string
 */
export function getColorCode(zone, colors) {
  let color = find(colors, x => zone === x.zone);

  if (!color) {
    return null;
  }

  return color.color;
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/common/colorCode.js